<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col v-if="currentTask.title && currentTask.title.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskName')" prop="title">
                            {{ currentTask.title }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.score && currentTask.score.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.score')" prop="score">
                            {{ currentTask.score }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.staff && currentTask.staff.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.staffLimit')" prop="staff">
                            {{ currentTask.staff > 0 ? currentTask.staff : t('improveDetail.unlimited') }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.start_time && currentTask.start_time.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSpecial.startTime')" prop="start_time">
                            {{ formatDisplayDateTime(currentTask.start_time) }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.end_time && currentTask.end_time.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSpecial.endTime')" prop="end_time">
                            {{ formatDisplayDateTime(currentTask.end_time) }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.description && currentTask.description.length > 0" :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskDesc')" prop="description">
                            {{ currentTask.description }}
                        </el-form-item>
                    </el-col>

                    <el-col v-if="fileList.length > 0" :span="24">
                        <el-form-item :label="t('improveDetail.taskMaterial')">
                            <hc-oss-image-list :value="currentTask.url" />
                        </el-form-item>
                    </el-col>

                    <el-divider></el-divider>
                    <el-col :span="24">
                        <el-form-item :label="t('improveDetail.submitter')">
                            {{ state.form.real_name }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.submitPhotos')">
                            <hc-oss-image-list :value="state.form.material_url" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.submitContent')">
                            {{ state.form.note }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.auditComment')" prop="comment">
                            <el-input v-model="state.form.comment" type="textarea" :rows="6" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSubmit.auditStatus')" prop="status">
                            <el-switch v-model="state.form.status" :active-value="2" :inactive-value="3"
                                :active-text="t('taskSubmit.pass')" :inactive-text="t('taskSubmit.reject')" />
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    reactive,
    ref,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { auditApi } from "@/api/task/special";
import { detailApi } from "@/api/task/submitRecord";
import { formatDisplayDateTime } from "@/utils/dateTime.js";
import { usePageI18n } from "@/composables/usePageI18n.js";

const applyLabels = () => {};
const { t } = usePageI18n(applyLabels);

const emit = defineEmits(["refresh"]);
defineProps({
    title: {
        type: String,
        default: "",
    },
});

const rules = reactive({});

const fileList = ref([]);
const getImgArr = (str) => {
    if (!str || str.length === 0) {
        return [];
    }
    try {
        return JSON.parse(str).map(i => i.url);
    } catch {
        return [];
    }
};

const state = reactive({
    dialogVisible: false,
    form: {
        id: 0,
        replied_by: 0,
        replied_name: "",
        comment: "",
        status: 2,
    },
});
const currentTask = ref({});

const resetForm = () => {
    state.form = {
        id: 0,
        replied_by: 0,
        replied_name: "",
        comment: "",
        status: 2,
    };
    fileList.value = [];
    currentTask.value = {};
};

const getDetailInfo = (row = {}) => {
    const recordId = row?.id;
    if (!recordId) {
        ElMessage.error(t('taskSubmit.missingRecordId'));
        return;
    }
    detailApi({ id: recordId }).then(res => {
        if (res.code !== 200 || !res.data) {
            ElMessage.error(res?.msg || t('taskSubmit.loadDetailFailed'));
            return;
        }
        const userTask = res.data.userSpecialTasks || {};
        const specialTask = res.data.specialTasks || {};
        try {
            fileList.value = JSON.parse(specialTask.url ?? "[]");
        } catch {
            fileList.value = [];
        }
        currentTask.value = specialTask;
        state.form = {
            id: recordId,
            replied_by: userTask.repliedBy ?? userTask.replied_by ?? row.replied_by ?? 0,
            replied_name: userTask.repliedName ?? userTask.replied_name ?? row.replied_name ?? "",
            comment: "",
            material_url: row.material_url,
            real_name: row.real_name,
            note: row.note,
            status: 2,
        };
    }).catch(() => {
        ElMessage.error(t('taskSubmit.loadDetailFailed'));
    });
};

const open = (row) => {
    resetForm();
    state.dialogVisible = true;
    getDetailInfo(toRaw(row));
};

const ruleForm = ref(null);
const submit = () => {
    if (!state.form.id) {
        ElMessage.error(t('taskSubmit.invalidRecordId'));
        return;
    }
    ruleForm.value.validate((valid) => {
        if (!valid) {
            return false;
        }
        const { user } = JSON.parse(localStorage.getItem("user") || "{}");
        const params = JSON.stringify({
            ...toRaw(state.form),
            replied_by: user?.users?.id,
            replied_name: user?.users?.realName,
        });
        auditApi(params).then(res => {
            if (res?.code === 200) {
                ElMessage.success(t('improveDetail.opSuccess'));
                state.dialogVisible = false;
                resetForm();
                emit("refresh");
            } else {
                ElMessage.error(res?.msg || t('improveDetail.opFailed'));
            }
        });
    });
};

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    margin-bottom: 0;
}

.record-img {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
